"use client";
/**
 * useOspLoginProvider 兼容层
 *
 * 原 SDK 通过 OspLoginClientContext 注入 authModule，
 * 现直接使用 appOspSecurity 创建的 authModule 单例
 */
import { appOspSecurity, createAppAuthModule } from "@/src/features/api/osp";
import type { IOspAuthModule } from "./sdk-types";

const authModuleSingleton: IOspAuthModule = createAppAuthModule(appOspSecurity);

export function useOspLoginProvider() {
  return { authModule: authModuleSingleton };
}
